// Captures UTM params from URL on first arrival and persists them for the
// duration of the session. Used by tracking.js (events) and by the create
// reservation endpoint (source attribution).
const KEY = "vm.utm.v1";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureUTM() {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(window.location.href);
    const found = {};
    UTM_KEYS.forEach((k) => {
      const v = url.searchParams.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length) {
      sessionStorage.setItem(KEY, JSON.stringify(found));
      return found;
    }
    const existing = sessionStorage.getItem(KEY);
    return existing ? JSON.parse(existing) : null;
  } catch {
    return null;
  }
}

export function getUTM() {
  if (typeof window === "undefined") return null;
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
}
